import { useState } from "react";
import { GoogleMap, Marker, useLoadScript, OverlayView } from "@react-google-maps/api";
import { setDefaults, fromLatLng } from "react-geocode";
import "./styles.css";
import i18n from "../../../i18n";
import config from "../../../constants/settings";
import { mapOptions } from "../MapServices/mapOptions";
import originMarker from "../../../assets/images/markers/origin.png";

export default function Map({ nameTitle, setNameTitle, selected, setSelected, hiddenArray, hiddenOne, setHiddenOne, addressRow, rowsScale, type, setRowsScale, id, setSelectedAddress, selectedAddress, setHiddenSecond, servicesView, setNewCreateAddressEmployee, typeAddress }) {

  const [ libraries ] = useState(['places']);
  const containerStyle = {
    height: '350px',
    width: '100%'
  };

  setDefaults({
    key: config.google.secret,
    language: "es",
    region: "mx",
  });

  const {isLoaded} = useLoadScript({
    googleMapsApiKey: config.google.secret,
    libraries: libraries,
    language: "es",
    region: "mx",
  });

  const getOriginMarkerIcon = () => originMarker;

  const onClickAccept = () => {
    switch(type){
      case 'one':
        setHiddenOne(true)
        break;
      case 'array':
        findHiddenRow()
        break;
      case 'destiny':
        setHiddenOne(true)
        break;
      case 'origin':
        setHiddenOne(true)
        break;
    }
  
    if(servicesView){
      setNewCreateAddressEmployee({ ...addressRow })
    }
  }

  const onClickCancel = () => {
    switch(type){
      case 'one':
        setHiddenOne(true)
        break;
      case 'array':
        findHiddenRow()
        break;
      case 'destiny':
        setHiddenOne(true)
        break;
      case 'origin':
        setHiddenOne(true)
        break;
    }
  }

  const onMarkerDragEnd = (event) => {
    const lat = event.latLng.lat();
    const lng = event.latLng.lng();
  
    fromLatLng(lat, lng)
      .then(({ results }) => {
        const formattedAddress = results[0]?.formatted_address;
        const { location } = results[0]?.geometry;
  
        if (formattedAddress) {
          if (type === "array") {
            const updatedRows = rowsScale.map((row) =>
              row.id === addressRow.id
                ? {
                    ...row,
                    address: {
                      ...row.address,
                      description: formattedAddress,
                      location: { lat: location.lat, lon: location.lng },
                    },
                  }
                : row
            );
            setRowsScale(updatedRows);
          } else {
            setSelected({ lat: location.lat, lng: location.lng });
  
            const updatedAddress = {
              ...selectedAddress,
              description: formattedAddress,
              location: { lat: location.lat, lon: location.lng },
            };
            setSelectedAddress(updatedAddress);
          }
  
          setNameTitle(
            i18n.t("TitleAddress", {
              typeAddress: getNameAddress(),
              address: formattedAddress,
            })
          );
        } else {
          console.error("A valid address could not be obtained.");
        }
      })
      .catch((error) => {
        console.error("Error getting address:", error);
      });
  };

  const getLabelMarker = () => {
    let name = "";
    let address = type === "array" ? addressRow?.address?.description : selectedAddress?.description;

    switch (type) {
      case "array":
        name = i18n.t("Additional");
        break;
      case "one":
        name = i18n.t("Address");
        break;
      default:
        name = "";
    }

    return (
      <div className="custom-label">
        <div className="marker-label-name">{name}</div>
        <div className="marker-label-address">{address}</div>
      </div>
    );
  };

  const getNameAddress = () => {
    let name = ""
    switch(type){
      case 'one':
        name = i18n.t("Predefined")
        break;
      case 'array':
        name = i18n.t("Aditional")
        break;
      case 'destiny':
        name = i18n.t("Destiny")
        break;
      case 'origin':
        name = i18n.t("Origin")
        break;
    }
    return name;
  }

  const findHiddenRow = () => {
    servicesView && setHiddenOne(true)
    let arr = rowsScale
    let fAddress = arr.filter(function(opt) {
      return opt.id === addressRow.id
    }).shift();
    if(fAddress){
      arr.splice(arr.indexOf(fAddress), 1)
      fAddress.addresssMap = true
      fAddress.editRow = true
      arr.push(fAddress)
      arr.sort((a, b) => (a.id > b.id) ? 1 : -1)
      setRowsScale([...arr])
    }
  }

  const checkDisabledBtn = () => {
    let disbaled = true
    switch(type){
      case 'one':
        disbaled = selectedAddress?.description ? false : true
        break;
      case 'array':
        disbaled = addressRow.address?.description ? false : true
        break;
      case 'destiny':
        disbaled = selectedAddress?.description ? false : true
        break;
      case 'origin':
        disbaled = selectedAddress?.description ? false : true
        break;
    }
    return disbaled;
  }

  if (addressRow?.editRow && type != "origin" && type != "destiny") return null;

  if ((hiddenArray || hiddenOne) && type != "origin" && type != "destiny") return null;
  
  if (!isLoaded) return <div>Loading..</div>;

  return (
    <>
      <div className={`places-container ${(type == "array") ? 'col-12' : ''}`}>
        <h6 className="employees-form-title">{nameTitle}</h6>
        <p className="employees-form-text">{i18n.t("SubtitleAddress")}</p>
        <GoogleMap
          zoom={16}
          center={(selected)}
          mapContainerStyle={containerStyle}
          mapContainerClassName="map-container"
          options={mapOptions}
        >
          {selected && (
            <>
              <Marker
                draggable={true}
                onDragEnd={onMarkerDragEnd}
                position={selected}
                icon={getOriginMarkerIcon()}
              />
              {(selectedAddress?.description || addressRow?.address?.description) && (
                <OverlayView
                  position={selected}
                  mapPaneName={OverlayView.FLOAT_PANE}
                >
                  <div>{getLabelMarker()}</div>
                </OverlayView>
              )}
            </>
          )}
        </GoogleMap>
      </div>
    </>
  )
}
